import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from './../../Global/jwtChecker' 
import logout from './../../Global/logout' 

export default async function CertUpload(clientUuid, formData, certificateAlias, password  ) {
    const unHashedJwt = await checkJwt()
 
    if(!unHashedJwt){
        logout()
    }

    let query = "?clientUuid=" + clientUuid + "&password=" + password + "&certificateAlias=" + certificateAlias 
    return await resolve(
        axios( 'provider/client/certificate' + query, {
            method: 'POST',
            headers: { 
                'Authorization' : unHashedJwt.data,
                'Content-Type': 'multipart/form-data'
            },
            data: formData
        }).then(
            res => (res)
        ).catch(error => error.response.data),
        "Admin"
    )
}